module.exports = __webpack_public_path__ + "img/ball-red.93fab28a.svg";